import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';
import SearchBars from 'components/SearchBars';
import Card from 'components/Card';
import Page from 'components/Page';
import SearchBarWrapper from 'components/SearchBarWrapper';
import { observer, inject } from 'mobx-react';
import { LoadError, Loading } from 'components/Tables/ScheduleList';
import AssignmentsTable from 'components/Tables/Assignments';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

@inject('store', 'jobStore', 'viewStore') @observer
class AssignmentsIndexPage extends Component {

  render() {
    let content;
    const { jobStore, viewStore } = this.props;
    const {
      props: {
        jobStore: {
          jobs: {
            isLoading,
            isError
          }
        }
      }
    } = this;
    if (isLoading && !isError) {
      content = <Loading variant="assignments" noun="assignments" />;
    }
    if (isError && !isLoading) {
      content = (
        <LoadError
          noun="assignments"
          search={viewStore.jobSearch}
          onRetry={() => jobStore.loadAssignments()}
          onNarrow={() => { viewStore.narrowJobDateRange(3); viewStore.assignments(); }}
        />
      );
    }
    if (!isError && !isLoading) {
      content = <AssignmentsTable />
    }
    return(
      <div>
        <Helmet>
          <title>Assignments | FieldNexus</title>
        </Helmet>
        <PageWrapGray>
          <SearchBars.Assignment key={this.props.viewStore.jobFiltersVersion} />
          <Card>
            {content}
          </Card>
        </PageWrapGray>
      </div>
    )
  }

};

export default AssignmentsIndexPage;